import { BuiltinBlockIds } from 'virtual:monospace-builtin-block-ids';
import { DEFAULT_BRAND_COLOR } from '#layers/ui/public';

/**
 * Shared brand-color form field for org and workspace settings.
 *
 * Omits `nullable`, so the field is non-clearable by default: no clear button
 * and it never emits `null`. `defaultOnNull` shows `DEFAULT_BRAND_COLOR` instead
 * of a blank swatch when the stored value is `null` (reachable only for the
 * workspace's nullable `primaryColor`; org `color` is non-null in the engine).
 */
export const BRAND_COLOR_FORM_FIELD = {
	block: BuiltinBlockIds.InputColor,
	default: () => DEFAULT_BRAND_COLOR,
	defaultOnNull: true,
} as const;
